import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../../../util/reactIntl';
import { NamedLink, ArrowButton, IconReviewStar, IconArrowRight, Button } from '../../../../../components';
import classNames from 'classnames';

import avatarImage from '../../../../../assets/images/gear-image.22b3aaa3.png'
import css from './SectionReviews.module.css';
import first from '../../../../../assets/images/first.jpg';
import second from '../../../../../assets/images/second.jpg';

const reviewList = [
    {
        icon: first,
        title: "Gary G.",
        message: "“Matt provided amazing work. Communication, punctuality and work was out-standing. Thanks!”"
    },
    {
        icon: second,
        title: "Sanjay A.",
        message: "“I was skeptical using Equipped at first but it matched me with perfectly matching painter.”"
    },
]

const SectionReviews = props => {
    const { rootClassName, className } = props;

    const classes = classNames(rootClassName || css.root, className);

    return (
        <div className={classes}>
            <div className={css.leftContent}>
                <div className={css.cards}>
                    {reviewList.map((item, i) => {
                        return (
                            <div className={css.card} key={i}>
                                <div className={css.reviewRating}>
                                    <IconReviewStar className={css.reviewStar} isFilled />
                                    <span className={css.reviewRatingCount}>5.0</span>
                                </div>
                                <div className={css.reviewUser}>
                                    <img className={css.avatarImage} src={item.icon} alt="Username" />
                                    <h3 className={css.avatarDisplayName}>{item.title}</h3>
                                </div>
                                <p className={css.reviewText}>{item.message}</p>
                                <div className={css.cardInfo}>
                                    <NamedLink name="SignupPage" className={css.cardInfoText}>
                                        Get matched today
                                        <svg className={css.rightArrow} width="10" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.563 4h6.875M5.625 1.188L8.438 4 5.624 6.813" stroke="#f15b26" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                                    </NamedLink>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <Button className={css.reviewsButtonMobile}>
                    Read reviews
                    <svg className={css.arrowButtonIcon} width="14" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 6h11M8 1.5L12.5 6 8 10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                </Button>
            </div>
            <div className={css.rightContent}>
                <div className={css.subTitle}>
                    Let's make a match
                </div>
                <div className={css.title}>
                    See what our customers are saying
                </div>
                <p className={css.text}>
                    Read real reviews from our customers. Our review process makes choosing highly rated professional easy.
                </p>
                <Button className={css.reviewsButtonDesktop}>
                    Read reviews
                    <svg className={css.arrowButtonIcon} width="14" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 6h11M8 1.5L12.5 6 8 10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                </Button>
            </div>
        </div>
    );
};

SectionReviews.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionReviews.propTypes = {
    rootClassName: string,
    className: string,
};

export default SectionReviews;
